import ErrorBoundary from "@/components/error-boundary.tsx";
import type { Nullable } from "@/types";
import { ConfigurationTab } from "../types";
import ConfiguratorModeActionButton from "./summary/configurator-mode-action-button.tsx";
import SummaryDetails from "./summary/summary-details.tsx";
import YourProductCode from "./summary/your-product-code.tsx";

const TABS = [ConfigurationTab.Design, ConfigurationTab.Light, ConfigurationTab.Accessory] as const;

type Props = { smartNumber: Nullable<string> };
export default function Summary({ smartNumber }: Props) {
    return (
        <>
            <YourProductCode smartNumber={smartNumber} />
            <ErrorBoundary>
                <ConfiguratorModeActionButton smartNumber={smartNumber} />
            </ErrorBoundary>
            {TABS.map((tab) => (
                <SummaryDetails key={tab} tab={tab} />
            ))}
        </>
    );
}
